module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-fullhd"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('tabs', {
    attrs: {
      "type": "boxed",
      "size": "medium",
      "id": "generalTab"
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": "User Info",
      "icon": "fa fa-user"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_vm._v("\n                  " + _vm._s(this.userInfo.email) + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfo.firstName),
      expression: "userInfo.firstName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userInfo.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfo, "firstName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfo.lastName),
      expression: "userInfo.lastName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userInfo.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfo, "lastName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "file is-primary has-name is-fullwidth is-right"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "name": "profilePicture",
      "id": "profilePicture"
    },
    on: {
      "change": function($event) {
        return _vm.fileChange()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "file-cta"
  }, [_c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v("\n                    Choose a file…\n                  ")])]), _vm._v(" "), _c('span', {
    staticClass: "file-name",
    staticStyle: {
      "background": "#fff"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.pictureName ? _vm.pictureName : 'Profile Picture') + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.editUser()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t      Submit\n\t\t\t\t\t    ")])])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Change Password",
      "icon": "fa fa-lock"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Old Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Password should be minimum 8 characters which contain at least one numeric digit and a special character.")])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Re-type New Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rePassword),
      expression: "rePassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.rePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rePassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.changePassword()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t      Submit\n\t\t\t\t\t    ")])])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n          Account Settings\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e47b27f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/accountSetting/AccountSetting.vue
// module id = 386
// module chunks = 5